
import PP01 from '../images/PokemonGo.gif';
import PGOScan from '../images/VPS-Scan.png';
import PGOEventImage from '../images/PGO-EventImage.png';
import PGOFlow01 from '../images/PGO-Flow-1.png';
import PGOFlow02 from '../images/PGO-Flow-2.png';
import Hackathon01 from '../images/Hackathon-01.gif';

import ScaniverseWeb from '../images/Scaniverse-webScreenshot.png';
import ScaniverseWebAssets from '../images/scaniverse-web-assets.png';
import ScaniverseWebScans from '../images/scaniverse-web-scans.png';
import ScaniverseMobileAssets from '../images/scaniverse-mobileAssets.png';
import ScaniverseMobileSites from '../images/scaniverse-mobileSites.png';
import ScaniverseMobile3Step from '../images/scaniverse-mobile-3step.png';
import ScaniverseTechnique from '../images/Scanning-technique-02.png';

import FerryBuilding from '../images/FerryBuilding.gif';
import LdlPhoto from '../images/LDL-Photo.png';
import multiplayerVPS2 from '../images/VPS-shared-02.gif';
import multiplayerVPS from '../images/VPS-shared.png';

import SpatialReconstruction from '../images/spatial-reconstruction.gif';
import remoteCollab from '../images/RC01.gif';
import remoteCollabVideo from '../images/RemoteCollabFull.mp4';
import remoteCollabDesign from '../images/RemoteCollab-placingcube.png';

import emojiGardenVideo from '../images/Emoji_Garden.mp4';
import remoteCollabScanning from '../images/remotecollab-scanning.png';

import projectFlora1 from '../images/FloraAndFungi-Screenshot-02.jpg';
import projectFlora2 from '../images/FloraAndFungi-Screenshot-03.jpg';
import projectFlora3 from '../images/MA-Thesis-Cover.png';
import projectFloraTrailer from '../images/EMcMillin_FloraFungi_Trailer.mp4';
import projectFloraShader from '../images/GhibliShadersGIF.gif';
import projectFloraTree from '../images/TreeAnimGifBIG.gif';
import projectFloraProcess from '../images/FloraProcess.mov';


import BB1 from '../images/BB01.png';
import BB2 from '../images/BB05.gif';
import BB3 from '../images/BB03.jpg';
import BB4 from '../images/BB-Surface-Bunker-Render-02.png';
import BBMeditation from '../images/BB-Meditation.jpg';
import BBLights from '../images/BB-lights.jpg';
import BBSetup from '../images/BB-setup.JPG';


import GH01 from '../images/GH_Screenshot2.png';
import GH02 from '../images/GH_Spirits.jpg';
import GHStartScreen from '../images/GHStartScreen.jpg';
import GH03 from '../images/GH_Screenshot.jpg';
import GHVeg from '../images/GH_Veg.png';

import remoteCollabProcess from '../images/Figma-Work-RC.png';
import DevX01 from '../images/website-homepage.png';
import DevX02 from '../images/Website-layout.png';
import DevX03 from '../images/Devx-Samples.png';
import DevxHeader from '../images/Image=DevX.png';
import StudioVPS01 from '../images/VPS-developers.jpg';
import StudioVPS02 from '../images/Turning on the Simulator.png';

import WearablesNavVideo from '../images/wearables-navigation.mp4';
import FerryBuildingNav from '../images/FerryBuildingdemo.mp4';

import CoverImagePGO from '../images/PGO-cover-img.png';
import CoverImageScaniverse from '../images/scaniverse-cover-img.png';
import CoverImageWayfinding from '../images/navigation-cover-img.png';
import CoverImageAR from '../images/ar-cover-img.png';

export const projects = [
    {
        id: 'pokemon-go',
        title: "Pokémon Go AR",
        category: "Product / UI / UX",
        type: "ux",
        coverImage: CoverImagePGO,
        images: [PGOEventImage, PP01, PGOScan, PGOFlow01, PGOFlow02],
        subtitle: "Design and UX for globally released Pokémon Go Playgrounds and Pokémon Go Snapshot.",
        description: "Lead the design on a multiyear effort to integrate VPS technology (Visual Positioning System) into Pokémon Go. I designed and helped develop the first VPS experience ever tested with Pokémon Go players, which informed the design for the global version that is out today.",
        tools: ["Unity", "Figma", "Shader VFX"],
        duration: "1.5 years",
        sections: [
            {
                heading: "Led design for new features",
                body: "I drove the UX and game design for the incorporation of new Niantic technology into Pokémon Go. My work established a framework for ensuring that players can engage with the features safely and informed the tools necessary to make this happen. Through thorough user testing, design iteration, and stakeholder alignment the features were released globally in Pokémon Go as GOSnapshot and Pokémon Playgrounds."
            },
            {
                heading: "Advanced tools and technology",
                body: "I designed the first prototypes ever testing our new visual positioning system with Pokémon Go players, which shaped the roadmap for Niantic technology and developer tools. The prototype was used to measure the accuracy of the new AR technology and my workflow informed tools necessary for engaging with Niantic's SDK."
            }
        ],
        businessImpact: [
            { label: "Global release" },
            { label: "10+ million users" },
            { label: "First VPS feature in Pokémon GO" }
        ],
    },

    {
        id: 'ar-research',
        title: "R&D for Augmented Reality Technologies",
        category: "Product / UI / UX",
        type: "ux",
        coverImage: CoverImageAR,
        images: [
            CoverImageAR,
            multiplayerVPS2,
            Hackathon01,
            multiplayerVPS,
            remoteCollab,
        ],
        subtitle: "Research and prototyping to evaluate new AR and spatial technologies for product integration.",
        description: "Designed and built prototypes to evaluate new AR and spatial technologies, collaborating with engineering and research teams to define product vision and establish UX best practices across mobile, headset, and desktop environments.",
        tools: ["Unity", "Figma", "C#"],
        duration: "Ongoing",    
        blocks: [
            {
                type: 'columns',
                items: [
                    {
                        heading: "Evaluate technology and customer needs",
                        body: "I design and build early prototypes that reveal how new AR and spatial technologies behave in real conditions while meeting directly with customers to understand their goals, workflows, and technical constraints. Through rapid iteration and discovery, I identify where our technology can create meaningful value, validate performance across mobile, headset, and desktop environments, and establish product vision grounded in both technical capabilities and real customer needs.",
                    },
                    {
                        
                        heading: "Design and deliver custom solutions",
                        body: "I translate technical capabilities into practical solutions for enterprise customers, designing end-to-end prototypes and experience designs tailored to their use-cases. I design and present pitch decks that communicate both product vision and technical feasibility, supporting business development across customers in entertainment, e-commerce, and government. I also produce marketing assets and visuals that support the BD team in driving adoption and closing partnerships."
                    }
                ]
            },
            {
                heading: "Design across mobile and web",
                body: "Co-led the design for Niantic Spatial's core scanning product, creating a cohesive experience that works seamlessly across mobile and web platforms. This required understanding the unique constraints and opportunities of each platform while maintaining consistent workflows and visual language that serves enterprise customers."
            },
            {
                heading: "Simplifying complex workflows",
                body: "In partnership with another designer, I focused on translating complex scanning processes and data management systems into intuitive flows that make sophisticated spatial technology accessible. By breaking down technical operations into clear, manageable steps, I enabled users to capture, process, and manage spatial data without needing to understand the underlying complexity."
            },
            {
                type: 'video',
                src: emojiGardenVideo,
            },
            {
                type: 'text',
                heading: "Multiplayer augmented reality",
                body: "This end-to-end sample was built to establish UX best practices for developers using Niantic Labs’ spatial technology. It guides users via a map to locations where games are available and allows multiple people to connect and play together. I led the UX for the navigation, localization, and process for letting players drop in and out of the gameplay seamlessly. This sample is a culmination of many months of user testing and research for the best ways to engage with this new AR technology.",
            },
            {
                type: 'video',
                src: remoteCollabVideo,
            },
            {
                type: 'image',
                src: remoteCollabScanning,
            },
            {
                type: 'image',
                src: remoteCollabDesign,
            },
            {
                type: 'text',
                heading: "Remote and onsite collaboration",
                body: "UX design for cross-platform collaboration tool used to evaluate technical readiness and support enterprise customers. The project allows users to connect to a physical space either on-site or from their devices remotely. The prototype incorporated new AR technology, which required a new method for users to scan a space as well as connect and load their content in a space. I designed a new method for this scanning and localization approach. The experience spans across desktop, mobile, and headsets.",
            },
        ]
    },

    {
        id: 'scaniverse',
        title: "Scaniverse",
        category: "Product / UI / UX",
        type: "ux",
        coverImage: CoverImageScaniverse,
        images: [
            CoverImageScaniverse,   // [0]  hero right column
            ScaniverseWeb,          // [1]  centeredImg (second-to-last)
            ScaniverseMobile3Step,  // [2]  fullWidthImg (last)
        ],
        subtitle: "Design and UX for web and mobile 3D scanning application.",
        description: "Co-led the design for Niantic Spatial's core scanning product across mobile and web. Translated complex 3D scanning workflows into intuitive experiences for enterprise customers managing spatial data at scale.",
        tools: ["Figma"],
        duration: "2024–2025",
        blocks:
        [
            {
                type: 'columns',
                items: [
                    {
                    heading: "Design across mobile and web",
                    body: "Co-led the design for Niantic Spatial's core scanning product, creating a cohesive experience that works seamlessly across mobile and web platforms. This required understanding the unique constraints and opportunities of each platform while maintaining consistent workflows and visual language that serves enterprise customers."
                    },
                    {
                    heading: "Simplifying complex workflows",
                    body: "In partnership with another designer, I focused on translating complex scanning processes and data management systems into intuitive flows that make sophisticated spatial technology accessible. By breaking down technical operations into clear, manageable steps, I enabled users to capture, process, and manage spatial data without needing to understand the underlying complexity."
                    }
                ]
            },
            {
                type: 'image',
                src: ScaniverseMobile3Step,
            },
            {
                type: 'text',
                heading: 'Capture, reconstruct, localize',
                body: 'Scaniverse combines these three core features into one, seamless product. The project is the culmination of years of UX research, many prototypes, and iterative technology improvements. I have designed and led projects that informed us how we can connect these disparate processes, as well as improve them individually.',
            },
            {
                type: 'image',
                src: ScaniverseWeb,
                caption: 'Gaussian splat preview'
            },
            {
                type: 'image',
                src: ScaniverseTechnique,
                caption: 'Scanning best practices',
            },
        ]
    },

    {
        id: 'navigation',
        title: "Navigation & Wayfinding",
        category: "Product / UI / UX",
        type: "ux",
        video: WearablesNavVideo,
        coverImage: CoverImageWayfinding,
        images: [
            CoverImageWayfinding,
            LdlPhoto,
            multiplayerVPS,
            Hackathon01,
        ],
        caption: ['Ferry Building VPS test', null, 'Multiplayer VPS', null],
        videoCaption: 'Wearable navigation prototype demo',
        subtitle: "Designing location-based navigation experiences that help users move through physical spaces with AR.",
        description: "Designed location-based navigation experiences using VPS and AR, helping users orient themselves and move through physical spaces with spatial overlays and real-time positioning.",
        tools: ["Figma", "Unity", "Niantic Spatial ARDK"],
        duration: "2023–2024",
        blocks: [
            {
                type: 'columns',
                items: [
                    {
                        heading: "Wayfinding & Navigation across disciplines",
                        body: "I specialize in wayfinding and navigation products, spanning from entertainment to enterprise grade implementations. I have designed end-to-end experiences that incorporated new technology without design precedent, taking a research forward approach to achieve a user-centered outcome. A collection of wayfinding solutions are presented below."
                    },
                    {
                        heading: "Designing with emerging technology",
                        body: "The following designs incorporate geospatial technology such as Visual Positioning System (VPS), World Pose and Slick, as well as mapping tools like Gaussian splats and meshes. In addition to my UX role on the projects, I developed a deep understanding of the technology and prototyping capabilities to understand on a deep level the limitations and capabilities of the tools. This allowed me to approach designing for not only the immediate project goals, but to inform the evolution of the technology for better usability, allowing for the later release of the developer tool Scaniverse."
                    },
                ]
            },
            {
                type: 'video',
                src: WearablesNavVideo,
            },
            {
                type: 'text',
                heading: "Navigation using wearables and AR",
                body: "In a focused hackathon sprint, we designed and built a custom hardware wearable that enables end-to-end navigation with seamless transitions from your handheld device to completely handsfree. The project explored how sound and audio inputs can be used to accompany navigation and reduce fatigue from holding the device up for viewing augmented reality features."
            },
            {
                type: 'video',
                src: FerryBuildingNav,
                size: 'small',
            },
            {
                type: 'text',
                heading: "Long Distance augmented reality navigation",
                body: "Designed end-to-end prototype to test key design and technical hypotheses and de-risk this high-priority technology. The prototype used mixed-methods to gather qualitative feedback while allowing researchers to control variables in real time."
            }
            
        ],
        sections: [
        ],
        
    },

    {
        id: 'spatial-collaboration',
        title: "Spatial Collaboration",
        category: "UX Design",
        type: "ux",
        images: [remoteCollab, remoteCollabProcess],
        description: "Lead the design for a spatial development experience, enabling users to connect from headset, mobile and desktop and collaborate remotely. The experience was used to both inform our technology and support our enterprise customers.",
        tools: ["Figma", "Unity", "Augmented Reality", "Magic Leap 2"],
        duration: "1 month",
    },
    {
        id: 'multiplayer-vps',
        title: "Multiplayer VPS experience",
        category: "UX Design",
        type: "ux",
        images: [multiplayerVPS2,
        multiplayerVPS],
        description: "Sample project developed to showcase location-based technology. I developed the UX best practices for our new technology. More details can be found in the documentation here https://www.nianticspatial.com/docs/ardk/emoji_garden/.",
        tools: ["Figma", "Unity"],
        duration: "2 months",
    },
    {
        id: 'developer-tools',
        title: "Developer Tools",
        category: "UX Design",
        type: "ux",
        images: [StudioVPS01, StudioVPS02, DevX01, DevX01, DevX02, DevX03, DevxHeader],
        description: "Lead the design for the integration of VPS and map tools into Niantic Studio, our visual development toolkit for web-based AR experience.",
        tools: ["Figma"],
        duration: "2 months",
    },
     {
        id: 'customer-delivery',
        title: "Customer Delivery",
        category: "UX Design",
        type: "ux",
        images: [SpatialReconstruction, remoteCollab, remoteCollabProcess],
        description: "Hackathon prototype exploring the integration of AI into navigation. The app uses an AI chatbot to provide information to the user, a wearable camera that gathers spatial understanding to provide accurate location data and semantics for the user's surrounding area. ",
        tools: ["Figma", "Bolt", "Niantic Spatial ARDK"],
        duration: "1 week",
    },
    {
        id: 'flora-and-fungi',
        title: "Flora and Fungi",
        category: "Game Design",
        type: "game",
        images: [
            projectFlora1,
            projectFlora2,
            projectFlora3
        ],
        description: "Exploring how we can become more empathetic to nature through games.",
        tools: ["Unity", "C#", "Blender", "Shader VFX"],
        duration: "3 months",
        blocks:
        [
            {
                type: 'columns',
                items: [
                    {
                        heading: "Game overview",
                        body: "Flora and Fungi is an ecosystem strategy game where players control mycelium, the hidden powerhouse of a forest, and are put in charge of the health of a forest. Through the mycelium network, players influence whether the forest flourishes or collapses.",
                    },
                    {
                        heading: "Master thesis project",
                        body: "The 2021 game was made as a solo project in conjunction with my master thesis ‘Nature in games: breaking biases and incorporating green nudges in games.” Sound design is from the incredible Meng Tian, who collaborated with me on building a score that evolves alongside the forest.",
                    }
                ]
            },
            {
                type: 'video',
                src: projectFloraTrailer,
            },
            {
                type: 'image',
                src: projectFlora1,
            },
            {
                type: 'image',
                src: projectFlora2,
            },
            {
                type: 'columns',
                    items: [
                    { src: projectFloraTree},
                    { src: projectFlora3,},
                    ]
            },
            {
                type: 'text',
                heading: "Master thesis project",
                body: "Flora and Fungi was developed as part of a larger master thesis project evaluating how nature is represented in games and if games can be used to encourage sustainable thinking. The thesis 'Nature in games: breaking biases and incorporating green nudges into games' dives into this relationship between the player and nature and discovers ways in which these 'green nudges' can change the players default behavior.",
            },
            {
                type: 'image',
                src: projectFloraShader,
            },
            {
                type: 'video',
                src: projectFloraProcess,
            },
            {
                type: 'text',
                heading: "Design, engineering, and testing",
                body: "I designed and built the entirety of Flora and Fungi on my own in Unity 3D. I created a shader that procedurally creates watercolor textures that brings an organic lightness to the game elements. A large challenge with the project was determining how mycelium, something that thrives outside our sight, would be visually represeented in the game. I created many variations for how it should work and consulted science journals until the final variation was accomplished.",
            }
        ]
    },
    {
        id: 'breath-beneath',
        title: "Breath Beneath",
        category: "Exhibition",
        type: "game",
        images: [
            BB2, BB1, BB3, BB4
        ],
        description: "An immersive art installation that brings light to the beauty of nature with every breath",
        tools: ["Unity", "Blender", "C#"],
        duration: "1 month",
        blocks:
        [
            {
                heading: "Game overview",
                body: "Breath Beneath was an immersive installation created for the Zürich Design Biennale. Visitors entered an underground bunker in the Zürich Botanical Gardens, where the ceiling above them illuminated with a living network of roots that responded to their breath. Using a Kinect sensor, silhouettes of people walking above were projected through the roots, creating a poetic connection between the seen and unseen layers of life. The experience was described by guests as “transcendent.”",
            },
            {
                type: 'image',
                src: BB1,
            },
            {
                type: 'columns',
                    items: [
                    { src: BBMeditation, heading: "Underground meditation", body: "Participants would lay on the three yoga mats in the bunker. With only the hum of their breath, the ceiling would light up above them. For the best results, they could breathe in unison."},
                    { src: BBLights},
                    ]
            },
            {
                type: 'image',
                src: BB2,
            },
            {
                type: 'text',
                heading: "Particles of the garden",
                body: "The particles projected on the ceiling would only light up while a participant breathes out. Only a particular frequency is allowed, so talking or shouting would make the particles disappear. When lit up, the particles would form into the shapes of the garden above. A camera on the surface would detect people walking above and project that into the particle show.",
            },
            {
                type: 'image',
                src: BB3,
            },
            {
                type: 'text',
                heading: "An underground journey",
                body: "Participants would walk down into a bunker and find their way into the second chamber, where they would lay on one of the three mats there.",
            },
            {
                type: 'image',
                src: BB4,
            },
            

        ]
    },
    {
        id: 'ghost-host',
        title: "Ghost Host",
        category: "game",
        type: "game",
        images: [GH01, GH02],
        description: "Educational game",
        tools: ["Unity", "C#", "Spline", "Blender"],
        duration: "5 months",
        blocks:
        [
            {
                type: 'columns',
                items: [
                    {
                        heading: "Game overview",
                        body: "The player must farm crops and raise livestock to feed as an offering to the ghosts who visit the shrine. If they fail to feed the ghosts, the ghosts will attack the shrine and the player will lose their farm. The player must strategize how to fit all the crops they can in their farm space, with each tile representing the amount of land needed by that food.",
                    },
                    {
                        heading: "An educational game",
                        body: "Ghost Host is an educational game for kids that was co-created with Zürich University of Applied Sciences. The game is designed to educate children in Switzerland on the land-usages of agriculture.",
                    }
                ]
            },
            {
                type: 'image',
                src: GHStartScreen,
            },
            {
                type: 'image',
                src: GH01,
            },
            {
                type: 'image',
                src: GH02,
            },
            {
                type: 'image',
                src: GH03,
            },
            {
                type: 'image',
                src: GHVeg,
            },
        ]
    }
];

// The 4 featured projects shown on the home page, in order
export const featuredProjects = ['pokemon-go', 'scaniverse', 'navigation', 'ar-research', 'flora-and-fungi', 'breath-beneath', 'ghost-host'].map(
    (id) => projects.find((p) => p.id === id)
).filter(Boolean);

export const skills = {
    skills: ["Figma", "design systems", "prototyping", "user research"],
    tools: ["Unity", "C#", "HTML/CSS", "AI tools", "3D software"]
};
